import { React, useState, useEffect } from "react";
import LoaderStyleOne from "../../components/LoaderStyleOne";
import { getData, postData } from "../../ServerRequest";
import MUIDataTable from "mui-datatables";
import { Grid, Typography, Box, TableCell } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

export default function Wishlist() {
  const [wishlistsData, setWishlistsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchWishlistsData() {
      let resData = await getData("/api/buyer/wishlist/");
      console.log(resData);
      let wishlists_data = resData["data"]["wishlist"];
      if (wishlists_data) {
        // Sort by latest to oldest (descending) using 'added_at' field
        const sortedData = [...wishlists_data].sort((a, b) => {
          return new Date(b.added_at) - new Date(a.added_at);
        });
        setWishlistsData(sortedData);
      } else {
        console.error("Error fetching wishlists data:", resData.message);
      }
      setLoading(false);
    }

    fetchWishlistsData();
  }, []);

  const formatDateTime = (utcDateTime) => {
    const date = new Date(utcDateTime);

    // Convert to IST (UTC+5:30)
    const istDate = new Date(date.getTime() + 5.5 * 60 * 60 * 1000);

    // Format date and time
    const datePart = istDate.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    const timePart = istDate.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });

    return { date: datePart, time: timePart };
  };

  // Custom sort icon renderer (same as other tables)
  const renderSortIcon = (columnMeta, sortOrder) => {
    if (sortOrder && sortOrder.index === columnMeta.index) {
      return sortOrder.direction === "asc" ? (
        <ArrowUpwardIcon style={{ fontSize: 16, marginLeft: 4, color: "#333" }} />
      ) : (
        <ArrowDownwardIcon style={{ fontSize: 16, marginLeft: 4, color: "#333" }} />
      );
    }
    return <ArrowUpwardIcon style={{ fontSize: 16, marginLeft: 4, color: "#ccc" }} />;
  };

  const columns = [
    {
      name: "id",
      label: "ID",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontFamily: "inter",
              fontWeight: 600,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
              cursor: "pointer",
            }}
            onClick={() => handleToggleColumn(columnMeta.index)}
          >
            {columnMeta.label}
            {renderSortIcon(columnMeta, sortOrder)}
          </TableCell>
        ),
        setCellProps: () => ({
          style: { textAlign: "center", fontWeight: 600 },
        }),
      },
    },
    {
      name: "product",
      label: "Product ID",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontFamily: "inter",
              fontWeight: 600,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
              cursor: "pointer",
            }}
            onClick={() => handleToggleColumn(columnMeta.index)}
          >
            {columnMeta.label}
            {renderSortIcon(columnMeta, sortOrder)}
          </TableCell>
        ),
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
      },
    },
    {
      name: "buyer",
      label: "Buyer ID",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontFamily: "inter",
              fontWeight: 600,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
              cursor: "pointer",
            }}
            onClick={() => handleToggleColumn(columnMeta.index)}
          >
            {columnMeta.label}
            {renderSortIcon(columnMeta, sortOrder)}
          </TableCell>
        ),
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
      },
    },
    {
      name: "phone_number",
      label: "Customer Phone No",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontFamily: "inter",
              fontWeight: 600,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
              cursor: "pointer",
            }}
            onClick={() => handleToggleColumn(columnMeta.index)}
          >
            {columnMeta.label}
            {renderSortIcon(columnMeta, sortOrder)}
          </TableCell>
        ),
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
      },
    },
    {
      name: "added_at",
      label: "Created Date",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontFamily: "inter",
              fontWeight: 600,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
              cursor: "pointer",
            }}
            onClick={() => handleToggleColumn(columnMeta.index)}
          >
            {columnMeta.label}
            {renderSortIcon(columnMeta, sortOrder)}
          </TableCell>
        ),
        customBodyRender: (value) => {
          if (!value) return "";
          const { date, time } = formatDateTime(value);
          return (
            <span>
              <strong>Date :</strong> {date} <br />
              <strong>Time :</strong> {time}
            </span>
          );
        },
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
      },
    },
  ];

  const options = {
    elevation: 0,
    filterType: "checkbox",
    responsive: "standard",
    tableBodyHeight: "calc(100vh - 64px - 48px)",
    tableBodyMaxHeight: "calc(100vh - 64px - 48px)",
    print: false, // Disable print
    download: false, // Disable download
    columns: false, // Disable column visibility
    viewColumns: false, // Disable view columns
    filter: false,
    search: true,
    selectableRows: "none", // Disable row selection
    textLabels: {
      body: {
        noMatch: loading ? "Loading..." : "Sorry, no matching records found",
      },
    },
  };

  return (
    <Box sx={{ width: "95%", paddingLeft: 3, mb: 5 }}>
      <Grid container sx={{ flex: 1, height: "100%" }}>
        <Box sx={{ width: "100%", height: "100%" }}>
          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 300 }}>
              <LoaderStyleOne />
            </Box>
          ) : (
            <Box sx={{ border: "2px solid #F4F3F6" }}>
              <MUIDataTable
                title={
                  <Typography
                    variant="body1"
                    sx={{ fontFamily: "Inter", fontWeight: 700, fontSize: 16 }}
                  >
                    Wishlist
                  </Typography>
                }
                data={wishlistsData}
                columns={columns}
                options={options}
              />
            </Box>
          )}
        </Box>
      </Grid>
    </Box>
  );
}
